import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'ns-my-documents-upload',
    templateUrl: './my-documents-upload.component.html',
    styleUrls: ['./my-documents-upload.component.scss']
})
export class MyDocumentsUploadComponent implements OnInit {

    public form: FormGroup;
    public fileId: string;
    public fileName: string;
    public currentStep = 1;

    @Output() save: EventEmitter<any> = new EventEmitter<any>();
    @Output() switchStep: EventEmitter<any> = new EventEmitter<any>();

    constructor(
        private formBuilder: FormBuilder,
    ) {
        this.form = formBuilder.group({
            id: [null, Validators.required],
            path: [null],
            name: [null, Validators.required],
            originalName: [null]
        });

        this.form.valueChanges.subscribe(val => {
            if (val && val.id !== null && val.id !== undefined) {
                // jest id pliku -> nastepny krok
                this.fileId = val.id;
                this.fileName = val.originalName;

                this.step2();
            }
        });
    }

    ngOnInit(): void {
    }

    public step2() {
        this.currentStep = 2;

        this.switchStep.emit(this.currentStep);
    }
    public step1() {
        this.currentStep = 1;
        this.form.reset();

        this.switchStep.emit(this.currentStep);
    }

    public saveFile() {
        const raw = this.form.getRawValue();

        this.form.get('name').markAsTouched();
        this.form.get('name').markAsDirty();
        this.form.updateValueAndValidity();

        if (!this.form.invalid) {
            delete raw.originalName;

            const content = {
                fileId: raw.id,
                name: raw.name
            };
            this.save.emit(content);
            this.step1();
        }
    }
}
